exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.svg-icon[data-v-e1de7874] {\n    width: 1em;\n    height: 1em;\n    vertical-align: -0.15em;\n    /*fill: steelblue;*/\n    fill: currentColor;\n    overflow: hidden;\n}\n", "", {"version":3,"sources":["C:/Program Files/WorkProgram/iview3/src/components/svgIcon/SvgIcon.vue"],"names":[],"mappings":";AACA;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;CACpB","file":"SvgIcon.vue","sourcesContent":["\n.svg-icon[data-v-e1de7874] {\n    width: 1em;\n    height: 1em;\n    vertical-align: -0.15em;\n    /*fill: steelblue;*/\n    fill: currentColor;\n    overflow: hidden;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-e1de7874","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/svgIcon/SvgIcon.vue
// module id = 687
// module chunks = 0